export default {
  header: {
    home: '首页',
    about: '关于我们',
    technology: '技术与创新',
    products: '产品展示',
    globalRegistration: '全球注册',
    services: '服务与支持',
    contacts: '联系我们',
    rawMaterial: '原材料定制',
    productCustomization: '产品定制',
    importExport: '进出口贸易'
  },
  home: {
    coreBusiness: '核心业务',
    platform: '新型药物递送平台',
    oneStopPlatform: '一站式产业链服务平台',
    formulation: '创新制剂',
    dosageForm: '剂型',
    dosageForms: {
      oralFilms: '口腔膜剂',
      transdermal: '透皮贴剂',
      granule: '口腔崩解颗粒'
    },
    application: '应用领域',
    applicationText: '儿童、老年人、特殊医疗状况患者、宠物',
    productStrategy: '产品策略设计',
    productInfo: '产品信息库与项目启动指导',
    productRegistration: '产品注册服务',
    salesMarket: '销售与市场开发',
    supplyDistribution: '原材料供应与产品分销及定制服务'
  },
  about: {
    companyProfile: '公司简介',
    location: '日本大阪 Seika Pharma',
    businessScopes: '业务范围：',
    scope1: '新生产服务开发',
    scope2: 'FDA 注册服务',
    scope3: '化妆品、健康食品、药品及辅料的海外业务',
    scope4: '宠物食品、宠物用品、饲料添加剂及宠物护理的零售与批发',
    missionVision: '使命与愿景'
  },
  footer: {
    exploration: '今日探索',
    innovation: '永恒创新',
    pioneering: '开拓',
    exploring: '探索',
    innovating: '创新',
    surpassing: '超越',
    subscribeNow: '立即订阅',
    subscribe: '订阅',
    contacts: '联系方式',
    email: '邮箱：',
    copyright: 'Seikaiyaku.com | 隐私政策© 2025 版权所有',
    copyrightMb: 'Copyright©2018-2025 Seikaiyaku.com 版权所有'
  },
  technology: {
    ddsTitle: 'DDS 与技术创新',
    oralFilms: '口腔薄膜（OTFs）',
    oralGranules: '口腔速溶颗粒（ODGs）',
    transdermalPatches: '透皮贴剂',
    technicalSupport: '技术支持',
    productDesign: '产品设计与技术援助。',
    comprehensiveSolutions: '全面的工业解决方案。',
    innovativePractice: '创新实践',
    effectiveFormula: '药品、宠物药物、',
    petNutrition: '宠物营养及健康食品的有效配方。',
    enhancingConvenience: '提高便利性与吸收效率。',
    purpleBanner: '涵盖药品、宠物药物、宠物营养及健康食品。'
  },
  contacts: {
    title: 'Seika Pharma 联系方式',
    contactsUs: '联系我们',
    registeredOffice: '办公地址',
    addressLabel: '地址：',
    address: '〒546-0002 大阪府大阪市东住吉区杭全1-17-17 3F',
    emailLabel: '邮箱：',
    sendMessage: '给我们留言',
    name: '姓名',
    email: '邮箱',
    subject: '主题',
    yourMessage: '您的留言',
    send: '发送'
  },
  products: {
    title1: '什么是还原型辅酶 Q10？',
    subtitle1: '还原型辅酶 Q10 胶囊焕发活力 - 超强吸收，最大效益！',
    body1: '泛醇（还原型辅酶 Q10）是人体自身物质，是身体自然产生细胞能量（ATP）所需的生命营养素',
    body2: '泛醇为细胞提供强大的抗氧化保护',
    body3: '泛醇是体内辅酶 Q10 的主要（99%+）活性形式',
    featuresTitle: '产品特点',
    feature1Title: '还原型辅酶 Q10',
    feature1Text: '无需转换，快速吸收，高生物利用度，比氧化型辅酶 Q10 效率高 8 倍',
    feature2Title: '优质成分',
    feature2Text: '日本顶级还原型辅酶 Q10，卓越的产品性能',
    feature3Title: '科学证据支持',
    feature3Text: '7 项关键科学研究支持其功效',
    detailsTitle: '产品详情',
    distributionTitle: '分销与购买',
    officialStore: 'Seika Pharma 官方商店',
    address: '地址：〒531-0073 大阪市东住吉区杭全 1-17-17 3F',
    email: '邮箱：info@seikaiyaku.com',
    details: {
      brand: '品牌：PHARMOPTIMA',
      name: '产品名称：还原型辅酶 Q10 胶囊',
      ingredients: '成分：橄榄油（西班牙制造）、辅酶 Q10（还原型）/ 改性淀粉、甘油、胶凝剂（多糖增稠剂）、蜂蜡、甘油脂肪酸酯、植物卵磷脂（大豆源）、焦糖色素、维生素 B6、维生素 B12、叶酸',
      content: '净含量：13.8g（460mg x 30 粒）',
      dosage: '建议用量：每日 1 粒，饭后温水吞服',
      nutrition: '营养成分（每粒）：能量 3.09kcal，蛋白质 0.01g，脂肪 0.27g，碳水化合物 0.16g，食盐相当量 0.003g，还原型辅酶 Q10 100mg'
    }
  },
  services: {
    title: '我们的服务',
    rawMaterialTitle: '原材料定制',
    rawMaterialDesc: '我们根据客户需求提供高质量的原材料定制服务。',
    productCustomizationTitle: '产品定制',
    productCustomizationDesc: '我们提供全面的产品定制解决方案，从配方到包装。',
    importExportTitle: '进出口贸易',
    importExportDesc: '我们促进全球贸易，确保进出口流程顺畅。'
  },
  popularize: {
    title: '推广策略',
    offlinePromotion: '线下推广',
    offlineP1: '参加行业展会',
    offlineP2: '举办产品发布会',
    offlineP3: '与当地分销商合作',
    onlinePlatform: '在线平台',
    onlineP1: '社交媒体营销',
    onlineP2: '搜索引擎优化 (SEO)',
    onlineP3: '电子邮件营销活动'
  },
  expansion: {
    title: '业务扩展',
    globalReach: '全球覆盖',
    globalReachDesc: '将我们的业务扩展到新市场和地区。',
    partnership: '战略合作伙伴关系',
    partnershipDesc: '与主要行业参与者建立联盟。'
  },
  material: {
    title: '材料科学',
    innovation: '材料创新',
    innovationDesc: '开发用于增强产品性能的新材料。',
    sustainability: '可持续性',
    sustainabilityDesc: '专注于环保和可持续材料。',
    titleMobile1: '材料',
    titleMobile2: '科学'
  },
  flow: {
    title: '生产流程',
    step1: '原材料采购',
    step2: '质量控制',
    step3: '制造',
    step4: '包装',
    step5: '最终检验',
    step6: '分销'
  },
  business: {
    title: '商业解决方案',
    consulting: '咨询服务',
    consultingDesc: '提供专家建议以优化业务运营。',
    strategy: '战略规划',
    strategyDesc: '制定长期增长和成功的战略。'
  },
  registration: {
    title: '注册服务',
    regulatoryAffairs: '监管事务',
    regulatoryAffairsDesc: '协助产品注册和合规。',
    documentDrafting: '文件起草',
    governmentCommunication: '政府沟通',
    processTracking: '流程跟踪'
  },
  globalRegistration: {
    heroTitle: '面向健康食品、医疗器械与化妆品的海外临床与注册一站式服务',
    coreTitle: '核心定位',
    processTitle: '全流程服务布局',
    positioning: {
      agent: {
        title: '海外法规注册代理',
        point1: '作为海外临床与注册项目的委托管理伙伴',
        point2: '对接法规机构与执行单位',
        point3: '统筹海外项目整体事务'
      },
      pm: {
        title: '项目管理主导',
        point1: '协调医院、检测机构、临床团队等各方资源',
        point2: '管理项目时间表与关键里程碑',
        point3: '推动项目执行与交付'
      },
      strategy: {
        title: '注册策略支持',
        point1: '制定注册路径与整体框架方案',
        point2: '提前识别并降低合规风险',
        point3: '提升项目执行效率'
      },
      coordination: {
        title: '跨境协同中枢',
        point1: '连接委托方与执行团队',
        point2: '统一技术理解与决策标准',
        point3: '减少沟通偏差'
      }
    },
    process: {
      research: {
        title: '前期调研与路径规划',
        point1: '分析产品属性与法规环境',
        point2: '规划注册与备案路径',
        point3: '制定整体项目排期'
      },
      evidence: {
        title: '整合型证据开发',
        point1: '协调安全性研究与临床评价',
        point2: '形成满足合规与市场需求的证据体系',
        point3: '围绕申报策略整合资料'
      },
      site: {
        title: '试验点选择与资源协调',
        point1: '筛选合适的实施机构与合作伙伴',
        point2: '协调任务分配、排期与资源',
        point3: '推动项目顺利落地'
      },
      management: {
        title: '过程管理与质量控制',
        point1: '提供覆盖受试者、样本、方案与报告的全程管理',
        point2: '监控关键节点偏差',
        point3: '优化成本与效率'
      },
      deliverables: {
        title: '成果物准备与多语言报告',
        point1: '输出多语言报告',
        point2: '支持目标市场申报资料整理',
        point3: '满足客户内部审核要求'
      }
    }
  },
  coq10: {
    auth: {
      accessDenied: '访问被拒绝',
      providePassword: '请提供正确的访问密码',
      enterPassword: '输入访问密码',
      confirm: '确认',
      incorrectPassword: '密码错误，请重试！',
      verificationSuccess: '验证成功！'
    },
    hero: {
      brandName: 'PHARMOPTIMA',
      productName: '还原型辅酶 Q10 胶囊',
      capacity: '100mg',
      subtitle: '超强吸收，最大效益，焕发活力！',
      reducedForm: '还原型',
      coq10: '辅酶 Q10'
    },
    info: {
      whatIsTitle: '什么是还原型辅酶 Q10？',
      whatIsText1: '泛醇（还原型辅酶 Q10）是人体自身物质，是身体自然产生细胞能量（ATP）所需的生命营养素。',
      whatIsText2: '泛醇为细胞提供强大的抗氧化保护。泛醇是体内辅酶 Q10 的主要（99%+）活性形式。',
      advantagesTitle: '优势',
      adv1Title: '健康心脏',
      adv1Text: '支持心血管健康和能量产生。',
      adv2Title: '优质品质',
      adv2Text: '源自日本顶级制造商。',
      adv3Title: '科学支持',
      adv3Text: '经临床研究验证的功效。'
    },
    productInfo: {
      title: '产品信息',
      targetUsersTitle: '适用人群',
      targetUsers1: '熬夜、易疲劳人群',
      targetUsers2: '中老年人',
      targetUsers3: '心血管疾病患者',
      targetUsers4: '慢性病患者',
      scopeTitle: '主要功效',
      scope1: '保护心肌细胞，增强心脏健康',
      scope2: '抗衰老',
      scope3: '提升日常活力',
      scope4: '改善身体合成必需物质的能力',
      ingredientsTitle: '主要成分',
      ingredient1: '还原型辅酶 Q10',
      ingredient2: '红花籽油',
      ingredient3: '甘油脂肪酸酯',
      ingredient4: '蜂蜡',
      specTitle: '规格与服用方法',
      spec1: '30 粒/瓶',
      spec2: '软胶囊',
      spec3: '每日 1 粒',
      marketTitle: '销售渠道',
      market1: '日本 / 膳食补充剂',
      market2: '跨境电商'
    },
    purchase: {
      buyNow: '立即购买',
      scanCode: '扫码购买',
      contactUs: '联系我们'
    }
  },
  meta: {
    home: '诚科医药',
    about: '关于我们 | 诚科医药',
    technology: '技术介绍 | 诚科医药',
    products: '产品介绍 | 诚科医药',
    contacts: '联系我们 | 诚科医药',
    platform: '平台 | 诚科医药',
    services: '服务 | 诚科医药',
    popularize: '推广 | 诚科医药',
    expansion: '海外业务 | 诚科医药',
    material: '原材料 | 诚科医药',
    flow: '生产流程 | 诚科医药',
    business: '进出口业务 | 诚科医药',
    registration: '药事申请・注册 | PHARM OPTIMA',
    coq10: '还原型 CoQ10 | PHARMOPTIMA',
    globalRegistration: '全球注册 | 诚科医药'
  }
}
